import tree from "../../../components/tree.vue"
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import { emailRule, domainName } from '@/utility/index.js'

export default {
    name: "JurisdictionalCompanies",
    components: { tree, iTable, IPagination },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                name: '',
                carExpiresType: '',
                insureType: '',
                safeList: ''
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.manufactureNum')
            }, {
                value: '3',
                label: this.$t('common.plateNum')
            }],
            StateList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            InsureList: [
                {
                    value: null,
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            dialogVisible: false,
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "name",
                    label: this.$t('common.companyName'),
                    align: "center",
                    width: "180",
                },
                {
                    prop: "carExpiresType",
                    label: this.$t('GovernmentRegulation.carExpiresType'),
                    align: "center",
                    width: "140px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.carExpiresType === null ? '' : params.row.carExpiresType === 0 ? 'success' : params.row.carExpiresType === 1 ? 'warning' : 'danger' }
                        }, params.row.carExpiresType === null ? '' : params.row.carExpiresType === 0 ? this.$t('common.normal') : params.row.carExpiresType === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                    }
                },
                {
                    prop: "insureType",
                    label: this.$t('GovernmentRegulation.insureType'),
                    align: "center",
                    width: "140px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.insureType === null ? '' : params.row.insureType === 0 ? 'success' : params.row.insureType === 1 ? 'warning' : 'danger' }
                        }, params.row.insureType === null ? '' : params.row.insureType === 0 ? this.$t('common.normal') : params.row.insureType === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                    }
                },
                {
                    prop: "safeList",
                    label: this.$t('GovernmentRegulation.safeList'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "brandName",
                    label: this.$t('GovernmentRegulation.brandName'),
                    align: "center",
                    width: "140",
                }, {
                    prop: "brandTypeName",
                    label: this.$t('GovernmentRegulation.brandTypeName'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "type",
                    label: this.$t('GovernmentRegulation.type'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "carEmissionName",
                    label: this.$t('GovernmentRegulation.carEmissionName'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "deliveryTime",
                    label: this.$t('VehicleManagement.deliveryTime'),
                    align: "center",
                    width: "180",
                },
                {
                    prop: "carSaveAddress",
                    label: this.$t('GovernmentRegulation.carSaveAddress'),
                    align: "center",
                    width: "200",
                }
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        };
    },
    created() {
        
    },
    mounted() {
        this.getJurisdictional()
    },
    methods: {
        getJurisdictional() {
            let param = {
                jurisdictionNum: sessionStorage.getItem('jurisdictionNum'),
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                name: this.formInline.name,
                carExpiresType: this.formInline.carExpiresType,
                insureType: this.formInline.insureType,
                safeList: this.formInline.safeList,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('JurisdictionalCompanies/GET_GETJURISDICTIONCAR', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },
        onSearch() {
            this.currentPage = 1
            this.getJurisdictional()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                name: '',
                carExpiresType: '',
                insureType: '',
                safeList: ''
            }
            this.getJurisdictional()
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getJurisdictional();
        },

        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
                    let url = `https://${domainName}/v1/getExportExcel/exportJurisdictionCar?jurisdictionNum=${jurisdictionNum}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&name=${this.formInline.name}&carExpiresType=${this.formInline.carExpiresType}&insureType=${this.formInline.insureType}&safeList=${this.formInline.safeList}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportJurisdictionCar?jurisdictionNum=${jurisdictionNum}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&name=${this.formInline.name}&carExpiresType=${this.formInline.carExpiresType}&insureType=${this.formInline.insureType}&safeList=${this.formInline.safeList}`
                    location.href = url
                }
            }
        },
    },
};
